<template>
	<div class="d-flex">
		<div style="width: 50%;">
			<div class="m-3 d-flex" style="justify-content: center;flex-flow: column;align-items: center;">
				<div style="font-size: 20px;font-weight: 800;margin-bottom: 5px;">任务完成度统计</div>
				<div style="color: #a8a8a8;font-size: 13px;">任务数量统计</div>
			</div>
			<div ref="myCharta" style="height: 500px;width: 100%;margin-top: 10px;margin-left: 10px;"></div>
		</div>
		<div style="width: 50%;">
			<div style="width: 100%;" class="d-flex m-2">
				<el-button type="primary" @click="onSubmit" size="mini">添加节点</el-button>
				<el-button type="primary" @click="onSubmit" size="mini">节点排序</el-button>
				<el-button type="primary" @click="onSubmit" size="mini">基本设置</el-button>
				<el-button type="danger" @click="onSubmit" size="mini">清空流程</el-button>
				<el-button type="success" @click="updata" size="mini">全部保存</el-button>
			</div>
			<div style="border: 1px solid rgb(0,0,0,0.1);box-shadow: 0 0  8px -6px;height: 560px;background: #fff;margin-left: 1%;">
				<div v-if="getid == 999"></div>
				<div v-else>
					<div class="m-3 d-flex"><div>节点信息</div></div>
					<div style="width: 100%;height: 1px;background: rgb(0,0,0,0.1);"></div>
					<el-form ref="form" label-width="80px" style="margin-left: 20px;margin-top: 30px;">
						<div style="width: 100%;" class="d-flex">
							<div style="width: 50%;">
								<el-form-item label="节点名称"><el-input v-model="yx[getid].name" style="width: 95%;"></el-input></el-form-item>
							</div>
							<div style="width: 50%;">
								<el-form-item label="状态码"><el-input v-model="yx[getid].ztm" style="width: 95%;"></el-input></el-form-item>
							</div>
						</div>
						<div style="width: 100%;">
							<el-form-item label="节点描述"><el-input v-model="yx[getid].jdms" style="width: 95%;"></el-input></el-form-item>
						</div>
						<div style="width: 100%;" class="d-flex">
							<div style="width: 50%;">
								<el-form-item label="执行部门">
									<el-select v-model="yx[getid].zxbm" placeholder="请选择" size="mini">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="流转节点">
									<el-select v-model="yx[getid].jdfl.target" style="margin-left: 20px;" placeholder="请选择">
										<el-option v-for="(item, index) in yx" :key="index" :label="item.name" :value="item.name"></el-option>
									</el-select>
								</el-form-item>
							</div>
							<div style="width: 50%;">
								<el-form-item label="执行员工">
									<el-select v-model="yx[getid].zxyg" placeholder="请选择" size="mini">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import 'echarts/map/js/china.js';
import * as vueEcharts from 'echarts';
let echarts = require('echarts');
export default {
	data() {
		return {
			getid: 999,
			num: 1000,
			myChart: null,
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				},
				{
					value: '选项3',
					label: '蚵仔煎'
				},
				{
					value: '选项4',
					label: '龙须面'
				},
				{
					value: '选项5',
					label: '北京烤鸭'
				}
			],
			yx: [
				{
					name: '开始',
					x: 0,
					y: 15,
					ztm: 1,
					jdms: '固定流程',
					zxbm: '无',
					zxyg: '无',
					jdfl: {
						source: '开始',
						target: '',
						lineStyle: {
							curveness: 0.2
						}
					},
					bdjd: ''
				},
				{
					name: '结束',
					x: 0,
					y: -15,
					ztm: 2,
					jdms: '固定流程',
					zxbm: '无',
					zxyg: '无',
					jdfl: {
						source: '结束',
						target: '',
						lineStyle: {
							curveness: 0.2
						}
					},
					bdjd: ''
				}
			],
			jdlist: [],
			lists:0
		};
	},
	created() {
		this.lists = this.$route.params.e
		console.log(this.lists)
	},
	mounted() {
		this.drawLine();
		this.jdfl();
	},
	methods: {
		clssa(e){
			console.log(e)
		},
		updata(){
			this.jdfl();
			this.drawLine();
			console.log(this.yx)
		},
		onSubmit() {
			this.num = this.num + 1;
			let news = {
				name: '节点' + this.num,
				ztm: this.num,
				x: 20,
				y: 20,
				jdms: '',
				zxbm: '无',
				zxyg: '无',
				jdfl: {
					source: '节点' + this.num,
					target: '',
					lineStyle: {
						curveness: 0.2
					}
				},
				bdjd: ''
			};
			let e = this.yx;
			e.push(news);

			//圆点坐标
			var dots = {
				x: 30,
				y: 30
			};

			//半径
			var radius = 30;
			//角度
			var angle = 0;
			//角度计算
			for (var i = 1; i < e.length + 1; i++) {
				//角度值
				var itemAngle = i * (360 / e.length);
				//坐标
				e[i - 1].x = dots.x + radius * Math.sin((itemAngle * 3.14) / 180);
				e[i - 1].y = dots.y + radius * Math.cos((itemAngle * 3.14) / 180);
			}

			this.yx = e;
			console.log(this.yx)
			this.jdfl();
			this.drawLine();
		},
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					tooltip: {},
					animationDurationUpdate: 1500,
					animationEasingUpdate: 'quinticInOut',
					series: [
						{
							type: 'graph',
							layout: 'none',
							symbolSize: 80,
							roam: true,
							label: {
								show: true
							},
							edgeSymbol: ['circle', 'arrow'],
							edgeSymbolSize: [4, 10],
							edgeLabel: {
								fontSize: 20
							},
							data: that.yx,
							links: that.jdlist,
							lineStyle: {
								opacity: 0.9,
								width: 2,
								curveness: 0
							}
						}
					]
				});
				myCharta.on('click', function(e) {
					that.getid = e.dataIndex;
					console.log(that.getid);
				});
			}, 50);
		},
		jdfl() {
			this.jdlist = this.yx.map(e => {
				return e.jdfl;
			});
			console.log(this.jdlist);
		}
	},
	beforeUnmount() {
		console.log('beforeUnmount');
		if (!myChart) {
			return;
		}
		myChart.dispose();
		let myChart = null;
	}
};
</script>

<style></style>
